/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const JumpToTopIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Jump To Top',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M22 22v11a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V22H5.007a.5.5 0 0 1-.354-.854L17 9l12.346 12.146a.5.5 0 0 1-.354.854Z"
    />
    <rect height="4" rx=".5" ry=".5" width="34" y="2" />
  </svg>`;
};
